export const apiRoutes = {
  assignAdvertisersToExternalUser: (userId: string) => `/users/${userId}/advertisers`,
};
